/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { contentModeCookieName } from "@insite/client-framework/Common/ContentMode";
import { getCookie } from "@insite/client-framework/Common/Cookies";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductsByTypeOptions, xAppState } from "@monsma/App/Store/Reducers";
import React from "react";
import { connect } from "react-redux";

const enum fields {
    showProductsByType = "showProductsByType",
}

interface FieldProps {
    fields: {
        [fields.showProductsByType]: string;
    };
}

const mapStateToProps = (state: xAppState) => ({
    selectedProductsType: state.xProductsByType?.selectedProductsType,
});

type Props = FieldProps & WidgetProps & ReturnType<typeof mapStateToProps>;

const ShowProductsByTypeViewer: React.FC<Props> = ({ id, selectedProductsType, fields }) => {
    const isCmsEditing = getCookie(contentModeCookieName) === "Editing";
    const { showProductsByType } = fields;

    if (isCmsEditing || selectedProductsType === showProductsByType) {
        return <Zone zoneName="ShowProductsByTypeViewer" contentId={id} />;
    }

    return null;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ShowProductsByTypeViewer),
    definition: {
        displayName: "Product By Type - Viewer",
        group: "Basic",
        fieldDefinitions: [
            {
                name: fields.showProductsByType,
                displayName: "Show Products By Type As:",
                editorTemplate: "DropDownField",
                options: ProductsByTypeOptions,
                defaultValue: "buildingMaterials",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
